import React, { FC } from 'react';
import { ItemsListWrapperWithoutRenderProps, ItemWrapperProps } from '@v2/pages/machines/common/types/props';
import ItemHistoryTime from '@components/common/ItemHistoryTime';
import ItemsListWrapper from '@v2/pages/machines/common/wrappers/ItemsListWrapper/ItemsListWrapper';

interface DefaultItemsListProps extends ItemsListWrapperWithoutRenderProps {}

const DefaultItemsList: FC<DefaultItemsListProps> = (props) => {
  return (
    <ItemsListWrapper
      {...props}
      additionalData={{
        maxValueActive: props.machineStatistics.maxValueActive,
        maxValueProductive: props.machineStatistics.maxValueProductive,
      }}
      getItemElement={({ item, C, selected, listWidth }: ItemWrapperProps) => (
        <ItemHistoryTime
          {...{
            item,
            C,
            selected,
            listWidth,
          }}
        />
      )}
    />
  );
};

export { DefaultItemsList };
